import React from 'react';
import { createTimeRegistration } from './logic/TimeRegistrationModalMutation';
import TimeRegistrationModalQueryWrapper from './query-wrappers/TimeRegistrationModalQueryWrapper';
const infoText = {
    headerText: 'Add time entry',
    creativeButtonText: 'Add time entry',
    cancelButtonText: 'Cancel',
};
function createModalTimeRegistration({ timeRegistrationMutationInput, closeModal }) {
    createTimeRegistration(timeRegistrationMutationInput);
    closeModal();
}
function TimeRegistrationModalCreate({ personId, entityId, closeModal, initialMinutes, initialBillableTime, initialDate, initialNote, initialRole, onCreateSuccess, }) {
    return (React.createElement(TimeRegistrationModalQueryWrapper, { personId: personId, entityId: entityId, initialMinutes: initialMinutes, initialBillableTime: initialBillableTime, initialDate: initialDate, initialNote: initialNote, initialRole: initialRole, infoText: infoText, callbackPositive: timeRegistrationMutationInput => createModalTimeRegistration({
            timeRegistrationMutationInput: Object.assign(Object.assign({}, timeRegistrationMutationInput), { onCreateSuccess }),
            closeModal,
        }), closeModal: closeModal }));
}
export default TimeRegistrationModalCreate;
